import * as Actions from '../actions';

const initialState = {
    currentExample: {}
};

const exampleReducer = function (state = initialState, action) {
    switch(action.type)
    {
        case(Actions.GET_EXAMPLE):
        {
            return {
                ...state, 
                currentExample: action.payload
            };
        }
        default:
        {
            return state;
        }
    }

};

export default exampleReducer;


// WEBPACK FOOTER //
// src/main/content/example/store/reducers/example.reducer.js